import { render, staticRenderFns } from "./ModifierListsEdit.vue?vue&type=template&id=22d14122&"
import script from "./ModifierListsEdit.vue?vue&type=script&lang=js&"
export * from "./ModifierListsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports